export default function PortalFooterClone() {
  return (
    <div style={{
      padding: "0px 20px",
      color: "#414F5A",
      fontSize: "11px",
      fontFamily: "Arial, Helvetica, sans-serif",
      height: "44px",
      marginTop: "-4px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }}>
      <div>Server: devEnv | Version11.0.0-dev</div>
      <div>© 2024 Vorro, Inc. dba BridgeGate. All Rights Reserved.</div>
      <div>Have a question? Visit: www.bridgegatedev.com</div>
    </div>
  )
}